module.exports = __webpack_public_path__ + "static/media/5.ec2099f3.png";